import React from 'react';
import { Link } from 'react-router-dom';
import './OrderSuccessPage.css';

const OrderSuccessPage: React.FC = () => {
  return (
    <div className="order-success-page">
      <div className="container">
        <div className="success-card">
          <div className="success-icon">
            <span>check_circle</span>
          </div>
          
          <h1>Order Placed Successfully!</h1>
          
          <p className="success-message">
            Thank you for your order. We've received your request and will start processing it right away.
          </p>
          
          <div className="order-details">
            <h3>What happens next?</h3>
            <ol>
              <li>You'll receive an order confirmation via SMS and email</li>
              <li>Our team will review your order and contact you within 24 hours</li>
              <li>Production will begin once all details are confirmed</li>
              <li>You'll receive updates on your order status</li>
              <li>Your order will be delivered as promised</li>
            </ol>
          </div>
          
          <div className="contact-info">
            <h3>Need Help?</h3>
            <p>If you have any questions about your order, feel free to reach out:</p>
            <div className="contact-methods">
              <div className="contact-method">
                <strong>Phone:</strong> +91 98765 43210
              </div>
              <div className="contact-method">
                <strong>Email:</strong> info@jkprints.com
              </div>
              <div className="contact-method">
                <strong>WhatsApp:</strong> +91 98765 43210
              </div>
            </div>
          </div>
          
          <div className="success-actions">
            <Link to="/" className="btn btn-primary btn-large">
              Continue Shopping
            </Link>
            <Link to="/products" className="btn btn-outline btn-large">
              Browse More Products
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
